module.exports = __webpack_public_path__ + "static/pic08.0bb08756.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic08.jpg
// module id = 518
// module chunks = 183886176117593